// extracted by mini-css-extract-plugin
export default {"container":"EventsPage_container_fKssQ","content":"EventsPage_content_VizE1"};